import React from "react";

import starIcon from "../../static/images/star-icon.png";

import process1 from "../../static/images/process/process1.png";
import process2 from "../../static/images/process/process2.png";
import process3 from "../../static/images/process/process3.png";
import process4 from "../../static/images/process/process4.png";
import process5 from "../../static/images/process/process5.png";
import process6 from "../../static/images/process/process6.png";

import shape from "../../static/images/shape/circle-shape1.png";

const processSteps = [
  {
    number: "01",
    image: process1,
    alt: "Business and cloud consultation",
    title: "Understand the Business Context",
    text: "We discuss your users, Microsoft cloud setup, compliance expectations, operational pain points, risk concerns, and what leadership needs to make a confident decision.",
  },

  {
    number: "02",
    image: process2,
    alt: "Microsoft cloud assessment",
    title: "Review Microsoft Cloud Controls",
    text: "We review Microsoft 365, Azure, Entra ID, MFA, Conditional Access, admin access, guest users, file sharing, licences, Defender posture, and governance settings.",
  },

  {
    number: "03",
    image: process3,
    alt: "Security and governance planning",
    title: "Prioritise the Real Risks",
    text: "We separate urgent exposure from lower-priority improvements so you know what could hurt the organisation, what to fix first, and what can wait.",
  },

  {
    number: "04",
    image: process4,
    alt: "Microsoft cloud implementation",
    title: "Implement Microsoft Security Controls",
    text: "We help apply practical controls across identity, access, sharing, devices, Defender, governance, migration, cloud administration, and support workflows.",
  },

  {
    number: "05",
    image: process5,
    alt: "Validation and audit readiness",
    title: "Validate Readiness and Usability",
    text: "We check that controls work, staff can still operate, access is accountable, and leadership has clearer evidence for governance or audit conversations.",
  },

  {
    number: "06",
    image: process6,
    alt: "Managed cloud support",
    title: "Support Ongoing Improvement",
    text: "We provide managed Microsoft cloud support, administration, troubleshooting, user guidance, and continuous improvement as the organisation changes.",
  },
];

const HowItWork = () => {
  return (
    <section className="process-area ptb-100">

      <div className="container">

        {/* ================= Header ================= */}

        <div className="section-title process-section-title">

          <span className="sub-title">
            <img src={starIcon} alt="" />
            How We Work
          </span>

          <h2>
            A Clear Process From Cloud Discovery to Practical Transformation
          </h2>

          <p>
            The goal is not a complicated report. The goal is a clear view of
            your Microsoft cloud exposure, a prioritised remediation path, and
            practical support to make the environment safer and easier to run.
          </p>

        </div>

        {/* ================= Process Cards ================= */}

        <div className="row justify-content-center">

          {processSteps.map((step, index) => (
            <div className="col-lg-4 col-md-6" key={index}>

              <div className="single-process-box modern-process-box">

                <div className="process-top">

                  <div className="number">
                    {step.number}
                  </div>

                  <div className="image">
                    <img src={step.image} alt={step.alt} />
                  </div>

                </div>

                <h3>{step.title}</h3>

                <p>{step.text}</p>

              </div>

            </div>
          ))}

        </div>

      </div>

      {/* ================= Background Shape ================= */}

      <div className="circle-shape1">
        <img src={shape} alt="" />
      </div>

    </section>
  );
};

export default HowItWork;
